import React, { useEffect, useMemo, useState } from 'react'
// import { SelectMantine } from '@ow/comps'
import clsx from 'clsx'
import { useTbViewStore } from '@vt/hooks'
import { pick, get, slice } from 'lodash-es'
import { Table, BlockRender } from '@ow/ditto'

const statisticsDefs = {
  statisticsFields: [],
  showTable: 'hidden',
  statisticsBySlug: {
    slug: 'createdAt',
  },
  type: 'statistics',
  slug: 'statistics',
  renderValue: true,
}

const SwitchChart = function ({ showModel, setShowModel }) {
  return (
    <div className="flex gap-2">
      <span
        title="表格"
        className={clsx(
          showModel === 'list' && 'dark:bg-darkTheme-900',
          'cursor-pointer w-8 h-8 flex items-center justify-center dark:hover:bg-darkTheme-900'
        )}
        style={{ borderRadius: '4px' }}
        onClick={() => {
          setShowModel('list')
        }}
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          className="icon icon-tabler icon-tabler-list-details cursor-pointer"
          width="22"
          height="22"
          viewBox="0 0 24 24"
          strokeWidth="2"
          stroke="currentColor"
          fill="none"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <path stroke="none" d="M0 0h24v24H0z" fill="none" />
          <path d="M13 5h8" />
          <path d="M13 9h5" />
          <path d="M13 15h8" />
          <path d="M13 19h5" />
          <rect x="3" y="4" width="6" height="6" rx="1" />
          <rect x="3" y="14" width="6" height="6" rx="1" />
        </svg>
      </span>
      <span
        title="柱状图"
        className={clsx(
          showModel === 'bar' && 'dark:bg-darkTheme-900',
          'cursor-pointer w-8 h-8 flex items-center justify-center dark:hover:bg-darkTheme-900'
        )}
        style={{ borderRadius: '4px' }}
        onClick={() => {
          setShowModel('bar')
        }}
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          className="icon icon-tabler icon-tabler-chart-bar cursor-pointer"
          width="22"
          height="22"
          viewBox="0 0 24 24"
          strokeWidth="2"
          stroke="currentColor"
          fill="none"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <path stroke="none" d="M0 0h24v24H0z" fill="none" />
          <rect x="3" y="12" width="6" height="8" rx="1" />
          <rect x="9" y="8" width="6" height="12" rx="1" />
          <rect x="15" y="4" width="6" height="16" rx="1" />
          <line x1="4" y1="20" x2="18" y2="20" />
        </svg>
      </span>
      <span
        title="条形图"
        className={clsx(
          showModel === 'line-bar' && 'dark:bg-darkTheme-900',
          'cursor-pointer w-8 h-8 flex items-center justify-center dark:hover:bg-darkTheme-900'
        )}
        style={{ borderRadius: '4px' }}
        onClick={() => {
          setShowModel('line-bar')
        }}
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          className="icon icon-tabler icon-tabler-chart-bar cursor-pointer"
          width="22"
          height="22"
          viewBox="0 0 24 24"
          strokeWidth="2"
          stroke="currentColor"
          fill="none"
          strokeLinecap="round"
          strokeLinejoin="round"
          style={{ transform: 'rotate(-270deg)' }}
        >
          <path stroke="none" d="M0 0h24v24H0z" fill="none" />
          <rect x="3" y="12" width="6" height="8" rx="1" />
          <rect x="9" y="8" width="6" height="12" rx="1" />
          <rect x="15" y="4" width="6" height="16" rx="1" />
          <line x1="4" y1="20" x2="18" y2="20" />
        </svg>
      </span>
      <span
        title="饼状图"
        className={clsx(
          showModel === 'pie' && 'dark:bg-darkTheme-900',
          'cursor-pointer w-8 h-8 flex items-center justify-center dark:hover:bg-darkTheme-900'
        )}
        style={{ borderRadius: '4px' }}
        onClick={() => {
          setShowModel('pie')
        }}
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          className="icon icon-tabler icon-tabler-chart-pie cursor-pointer"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          strokeWidth="2"
          stroke="currentColor"
          fill="none"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <path stroke="none" d="M0 0h24v24H0z" fill="none" />
          <path d="M10 3.2a9 9 0 1 0 10.8 10.8a1 1 0 0 0 -1 -1h-6.8a2 2 0 0 1 -2 -2v-7a0.9 .9 0 0 0 -1 -.8" />
          <path d="M15 3.5a9 9 0 0 1 5.5 5.5h-4.5a1 1 0 0 1 -1 -1v-4.5" />
        </svg>
      </span>
    </div>
  )
}

const forbidSlugs = ['tableDataId', 'standardName']
const showSlugs = ['standardName']
const ChartContainer = function ({ beforeTransform }) {
  const {
    fields,
    tbData,
    listConfig,
    ditto,
    selectedIds,
    columnShowType,
    recoverTbData,
    setSelectedIds,
    setSorts,
    loading,
    setColumnShowType,
    showOperation,
  } = useTbViewStore((state) =>
    pick(state, [
      'fields',
      'tbData',
      'listConfig',
      'selectedIds',
      'columnShowType',
      'recoverTbData',
      'setSelectedIds',
      'loading',
      'ditto',
      'setSorts',
      'setColumnShowType',
      'showOperation',
    ])
  )

  const [showModel, setShowModel] = useState('list')

  const config = useMemo(() => {
    const arr = columnShowType.filter((v) => !forbidSlugs.includes(v.slug))
    const showArr = showSlugs.map((v) => {
      return { slug: v, showType: 'sticky' }
    })
    return {
      ...listConfig,
      fields: [...showArr, ...arr],
    }
  }, [listConfig, columnShowType])

  // 当前要统计的数据
  const selectedData = useMemo(() => {
    return selectedIds.length > 0
      ? tbData.filter((v) => slice(selectedIds, 0, 5).includes(v.objectId))
      : slice(tbData, 0, 5)
  }, [selectedIds, tbData])

  // 注意要过滤筛选条件
  const statisticsData = useMemo(() => {
    const slugs = get(config, 'fields', [])
      .filter((v) => v.showType === 'show' && !forbidSlugs.includes(v.slug))
      .map((v) => v.slug)

    const content = slugs.map((v) => {
      const obj = {}
      selectedData.forEach((d) => {
        obj[d.standardName] = d[v]
      })
      return { ...obj, createdAt: v }
    })
    return { content }
  }, [config, columnShowType, selectedData, tbData])

  const finalStatisticsDefs = useMemo(() => {
    const arr = selectedData.map((v) => {
      return {
        type: showModel,
        title: v.standardName,
      }
    })
    return { ...statisticsDefs, statisticsFields: arr }
  }, [selectedData, tbData, showModel])

  useEffect(() => {
    if (showModel !== 'list') {
      setSelectedIds(slice(tbData, 0, 5).map((v) => v.objectId))
    } else {
      setSelectedIds([])
    }
  }, [tbData, showModel])

  useEffect(() => {
    if (showModel !== 'list' && selectedIds.length === 0) {
      setSelectedIds(slice(tbData, 0, 5).map((v) => v.objectId))
    }
  }, [selectedIds])

  return (
    <div className="w-full h-full flex flex-col">
      <div className="w-full flex-3 mb-6">
        <div className="flex h-16 -mt-2 w-full items-center justify-between dark:border-b dark:border-darkTheme-800 dark:border-solid">
          <SwitchChart setShowModel={setShowModel} showModel={showModel} />
          {/* <div className="w-48">
            <SelectMantine
              styles={{
                dropdown: {
                  borderStyle: 'solid',
                },
              }}
              onChange={setCondition}
              value={condition}
              options={[
                { value: 5, label: '最近5年' },
                { value: 10, label: '最近10年' },
              ]}
            />
          </div> */}
        </div>
      </div>

      {showModel !== 'list' && (
        <div className="w-full flex-3 flex-1 h-full">
          {showModel === 'bar' && (
            <BlockRender
              value={statisticsData}
              defs={finalStatisticsDefs}
              rowData={{ statistics: statisticsData }}
              fields={[finalStatisticsDefs]}
              className="w-full h-full"
            />
          )}
          {showModel === 'line-bar' && (
            <BlockRender
              value={statisticsData}
              defs={finalStatisticsDefs}
              rowData={{ statistics: statisticsData }}
              fields={[finalStatisticsDefs]}
              className="w-full h-full"
            />
          )}
          {showModel === 'pie' && (
            <BlockRender
              value={statisticsData}
              defs={finalStatisticsDefs}
              rowData={{ statistics: statisticsData }}
              fields={[finalStatisticsDefs]}
              className="w-full h-full"
            />
          )}
        </div>
      )}

      <div className="w-full flex-4 flex-1">
        <Table
          fields={fields}
          tbData={tbData}
          loading={loading}
          isShowSelections
          selectedIds={selectedIds}
          mergeCellInfo={ditto.mergeCellInfo}
          beforeTransform={beforeTransform}
          onChangeSelected={setSelectedIds}
          onChangeSorts={setSorts}
          config={config}
          recoverTbData={recoverTbData}
          columnShowType={columnShowType}
          onChangeColumnShowType={setColumnShowType}
          showOperation={showOperation}
        />
      </div>
    </div>
  )
}

export default ChartContainer
